'use strict';
(function () {
  angular.module('pentaApp').factory('reservationCalendar.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/reservationCalendar');
  }
})();
